<abc-qrcode-scanner #abcQrCodeScanner></abc-qrcode-scanner>
@if (
  {
    validatedWebApiInfo: (validatedWebApiInfo$ | async),
    isValidatingWebApiURL: (isValidatingWebApiURL$ | async),
  };
  as validationObservables
) {
  <div id="rootContainer" class="root-container" fxLayout="row" fxLayoutAlign="center center">
    <div
      class="scrollable-container"
      fxFlex="50%"
      fxFlex.lt-sm="95%"
      fxFlex.sm="80%"
      fxFlex.md="70%"
      fxFlex.lg="100%"
      fxFlex.gt-lg="100%"
      fxLayout="column"
      fxLayoutAlign="start stretch"
      fxLayoutGap="15px"
      fxLayoutGap.lt-sm="10px"
      class="editor-container {{ errorClass ? ' ' + errorClass : '' }} "
    >
      <mat-label fxFlex="none" class="intro-text">{{ this.res.get('WebApiEditor-IntroText') }}</mat-label>
      <mat-form-field appearance="fill" fxFlex="none">
        <mat-label class="editor-label">{{ this.res.get('WebApiEditor-BasicURL') }}</mat-label>
        <input
          matInput
          ngClass="input-editor"
          ngClass.lt-sm="input-editor small-font"
          [(ngModel)]="currentBaseURL"
          type="text"
          [disabled]="validationObservables.isValidatingWebApiURL"
        />
        @if (isQRCodeScanSupported && hasMediaStream) {
          <button
            mat-icon-button
            matSuffix
            (click)="scanQRCode()"
            [disabled]="validationObservables.isValidatingWebApiURL"
            [matTooltip]="this.res.get('WebApiEditor-QRCodeScan')"
          >
            <mat-icon [svgIcon]="res.svgName('QRCodeScan-Image')"></mat-icon>
          </button>
        }
      </mat-form-field>
      <button
        mat-flat-button
        class="text-button validate"
        type="button"
        (click)="validateCurrentBaseURL(false)"
        [matTooltip]="this.res.get('WebApiEditor-CheckURL')"
        [disabled]="!currentBaseURL || validationObservables.isValidatingWebApiURL || isApplyingWebApiURL"
      >
        {{ this.res.get('Check').toUpperCase() }}
      </button>
      @if (
        !validationObservables.isValidatingWebApiURL &&
        !isApplyingWebApiURL &&
        !ErrorMessage &&
        validationObservables.validatedWebApiInfo
      ) {
        <div fxFlex="none">
          @if (currentBaseURL && currentBaseURL === validationObservables.validatedWebApiInfo.baseURL) {
            <mat-card class="details-card">
              @if (!lastWebApiValidationErrorMessage) {
                <mat-card-header>
                  <div mat-card-avatar class="validation-result-image success">
                    <mat-icon [svgIcon]="res.svgName('ValidationSuccess-Image')"></mat-icon>
                  </div>
                  <mat-card-title>{{ this.res.get('WebApiEditor-URLCheckSuccess') }}</mat-card-title>
                </mat-card-header>
              }
              @if (lastWebApiValidationErrorMessage) {
                <mat-card-header>
                  <div mat-card-avatar class="validation-result-image failed">
                    <mat-icon [svgIcon]="res.svgName('ValidationFailed-Image')"></mat-icon>
                  </div>
                  <mat-card-title>{{ lastWebApiValidationErrorMessage }}</mat-card-title>
                </mat-card-header>
              }
              @if (!validationObservables.validatedWebApiInfo.isBaseURLInvalid) {
                <mat-card-content>
                  <div
                    fxFill
                    fxLayout="row"
                    fxLayout.lt-sm="column"
                    fxLayoutAlign="space-between stretch"
                    fxLayoutGap="10px"
                    class="webapi-details"
                  >
                    <div fxFlex="flex">
                      <div
                        class="web-api-details-table"
                        fxFill
                        gdAreas="
              lblDisplayText valDisplayText lblNeedsAuthentication valNeedsAuthentication |
              lblVersion valVersion lblUseLocalSecurityContext valUseLocalSecurityContext |
              lblSystem valSystem lblRemoteSecurityContext valUseRemoteSecurityContext"
                        gdColumns="1fr 2fr 2fr 1r"
                        gdRows="auto auto auto"
                        gdAreas.lt-sm="
              lblDisplayText valDisplayText |
              lblVersion valVersion |
              lblSystem valSystem |
              lblNeedsAuthentication valNeedsAuthentication |
              lblUseLocalSecurityContext valUseLocalSecurityContext |
              lblRemoteSecurityContext valUseRemoteSecurityContext"
                        gdColumns.lt-sm="1fr 1fr"
                        gdRows.lt-sm="auto auto auto auto auto auto"
                        gdGap="10px"
                      >
                        <div gdArea="lblDisplayText">{{ this.res.get('WebApiEditor-Name') }}</div>
                        <div gdArea="valDisplayText">{{ validationObservables.validatedWebApiInfo.displayText }}</div>
                        <div gdArea="lblVersion">{{ this.res.get('WebApiEditor-Version') }}</div>
                        <div gdArea="valVersion">{{ validationObservables.validatedWebApiInfo.version }}</div>
                        <div gdArea="lblSystem">{{ this.res.get('WebApiEditor-System') }}</div>
                        <div gdArea="valSystem">{{ validationObservables.validatedWebApiInfo.systemInfo.Name }}</div>
                        <div gdArea="lblNeedsAuthentication">{{ this.res.get('WebApiEditor-NeedsAuth') }}</div>
                        <div gdArea="valNeedsAuthentication">
                          {{ validationObservables.validatedWebApiInfo.needsAuthentication ? 'ja' : 'nein' }}
                        </div>
                        <div gdArea="lblUseLocalSecurityContext">
                          {{ this.res.get('WebApiEditor-UsesServerUserContext') }}
                        </div>
                        <div gdArea="valUseLocalSecurityContext">
                          {{ validationObservables.validatedWebApiInfo.useLocalSecurityContext ? 'ja' : 'nein' }}
                        </div>
                        <div gdArea="lblRemoteSecurityContext">
                          {{ this.res.get('WebApiEditor-UsesClientUserContext') }}
                        </div>
                        <div gdArea="valUseRemoteSecurityContext">
                          {{ validationObservables.validatedWebApiInfo.useRemoteSecurityContext ? 'ja' : 'nein' }}
                        </div>
                      </div>
                    </div>
                    <div fxFlex="nogrow">
                      <div class="web-api-details-qr" fxFill fxLayout="row" fxLayoutAlign="center center">
                        <!-- <img
                        [src]="getWebApiQRImageURL(validationObservables.validatedWebApiInfo.baseURL)"
                        alt="QR Code"
                        width="100"
                        width="100"
                        [title]="this.res.get('WebApiEditor-WebApiDetailQR')"
                        /> -->
                        <abc-qrcode-viewer
                          [qrData]="getWebApiQRImageURL(validationObservables.validatedWebApiInfo.baseURL)"
                          [title]="this.res.get('WebApiEditor-WebApiDetailQR')"
                          [width]="'100px'"
                          [height]="'100px'"
                          [color]="'var(--PrimaryMainShading60)'"
                        ></abc-qrcode-viewer>
                        <!-- <div #qr_image_placeholder
                        style="border: 1px solid; padding: 0px; margin: 0px;width: 100px; min-width: 100px; height: 100px; min-height: 100px;">
                        <div fxLayout="row" fxFill fxLayoutAlign="center center">QR</div>
                      </div> -->
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              }
            </mat-card>
          }
        </div>
      } @else {
        @if (currentBaseURL && !ErrorMessage && !isApplyingWebApiURL) {
          <mat-card class="details-card">
            <ng-container
              *ngTemplateOutlet="progressTemplate; context: { $implicit: this.res.get('WebApiEditor-URLValidation') }"
            >
            </ng-container>
          </mat-card>
        }
      }
      @if (isApplyingWebApiURL && !ErrorMessage) {
        @if (currentBaseURL && !ErrorMessage) {
          <mat-card class="details-card">
            <ng-container
              *ngTemplateOutlet="progressTemplate; context: { $implicit: this.res.get('WebApiEditor-URLApply') }"
            >
            </ng-container>
          </mat-card>
        }
      }
      @if (ErrorMessage && !isApplyingWebApiURL) {
        <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
          <div class="waring">
            <mat-icon
              ngClass="iconError"
              ngClass.lt-sm="iconError small"
              [svgIcon]="res.svgName('Warning-Image')"
            ></mat-icon>
          </div>
          <div class="msgError">{{ this.res.get('WebApiEditor-Error') }}</div>
          @if (isUserFriendlyErrorMessage) {
            <div class="descriptionError">
              <span>{{ ErrorMessage }}</span>
            </div>
          }
          @if (!isUserFriendlyErrorMessage) {
            <div class="descriptionError" [title]="ErrorMessage">
              <span>{{ this.res.get('WebApiEditor-ErrorDescriptionMessage') }}</span>
            </div>
          }
        </div>
      }
      <button
        mat-raised-button
        class="text-button save"
        type="button"
        [matTooltip]="this.res.get('WebApiEditor-ApplyAndSave')"
        [disabled]="!currentBaseURL || validationObservables.isValidatingWebApiURL || isApplyingWebApiURL"
        (click)="validateCurrentBaseURL(true)"
      >
        {{ this.res.get('Save').toUpperCase() }}
      </button>
      <button
        mat-stroked-button
        class="text-button cancelWebApiChange"
        type="button"
        [matTooltip]="this.res.get('WebApiEditor-CancelAndReturn')"
        (click)="cancel()"
      >
        {{ this.res.get('Cancel').toUpperCase() }}
      </button>
    </div>
    <ng-template #progressTemplate let-message>
      <div class="loaderClass {{ errorClass ? ' ' + errorClass : '' }}">
        <div class="msgStyle dark">{{ message }}</div>
        <dx-load-indicator [visible]="true"></dx-load-indicator>
      </div>
    </ng-template>
  </div>
}
